/*
FormNumber is a v-text-field based on number type.
Parent components can syncronize their date fields with FormNumber as follows:

            <FormNumber
              v-model="parent value"
              :label="field label"
              fieldProps="field properties"
            />
*/
import validationMixin from '../utils/validationMixin'
import simpleInputWrapper from '../utils/simpleInputWrapper'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormNumber',
  mixins: [simpleInputWrapper, validationMixin, textFieldMixin],

  props: {
    value: [Number, String],
    numberType: String
  },

  methods: {
    checkNumberInput (numberType = 'float', event) {
      return numberType === 'integer' ? this.checkIntegerNumber(event) : this.checkDoubleNumber(event)
    },

    // keyCode = 8 -> Backspace
    // keyCode = 46 -> Delete
    checkIntegerNumber (event) {
      if (!(event.keyCode === 8 || event.keyCode === 46) && isNaN(Number(event.key))) {
        event.preventDefault()
      }
    },

    // keyCode = 69 -> e
    checkDoubleNumber (event) {
      if (event.keyCode === 69) {
        event.preventDefault()
      }
    }
  }
}
